import { render, staticRenderFns } from "./SpaceResearch.vue?vue&type=template&id=0ba05efc&scoped=true"
import script from "./SpaceResearch.vue?vue&type=script&lang=js"
export * from "./SpaceResearch.vue?vue&type=script&lang=js"
import style0 from "./SpaceResearch.vue?vue&type=style&index=0&id=0ba05efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba05efc",
  null
  
)

export default component.exports